import { Tab, Tabs } from "@nextui-org/react";
import React from "react";
import { useParams } from "react-router-dom";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import EditJsonSurveyBuilder from "./EditJsonSurveyBuilder";
import EditUISurveyBuilder from "./EditUISurveyBuilder";

/**
 * EditSurveyBuilder Component
 * Survey editing interface with tabbed navigation
 * Provides two approaches: UI-based form builder and JSON-based configuration
 * @returns {JSX.Element} Survey editor main interface
 */
export const EditSurveyBuilder = () => {
  // Organization ID from URL parameters
  const { _orgId: currentOrg } = useParams();

  // Available survey editing methods
  const surveyEditorTabs = [
    {
      id: "Using Form Builder UI",
      label: "Using UI Builder",
      content: <EditUISurveyBuilder />,
    },
    {
      id: "Using JSON",
      label: "Using JSON",
      content: <EditJsonSurveyBuilder />,
    },
  ];

  return (
    <BreadCrumbsPage>
      <div className="w-full">
        {/* Page Header */}
        <div className="text-3xl font-medium">Edit a Survey</div>
        
        {/* Page Description */}
        <div className="my-8">
          Edit a survey and build that would support your ESG Reporting
        </div>
        
        {/* Survey Editor Tabs */}
        <Tabs aria-label="Survey editor tabs" items={surveyEditorTabs} variant="light">
          {(tab) => (
            <Tab key={tab.id} title={tab.label}>
              {tab.content}
            </Tab>
          )}
        </Tabs>
      </div>
    </BreadCrumbsPage>
  );
};
